import Axios from "../../services/axios-service";

const getTravelersList = data => {
  return Axios.get("/users/?search=" + JSON.stringify(data), undefined);
};

export default {
  getTravelersList
};
